import { Component, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { Observable } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';
@Component({
    selector: 'ef-company-calendar-feature',
    templateUrl: './company-calendar-feature.component.html',
    styleUrls: ['./company-calendar-feature.component.scss'],
    standalone: false
})
export class CompanyCalendarFeatureComponent implements OnInit {
    companyCalendarDataService: EntityCollectionService<fromDataServices.CompanyCalendar.CompanyCalendar>;
    public companyDates$: Observable<
        fromDataServices.CompanyCalendar.CompanyCalendar[]
    >;
    events: any[] = [];
    active = true;
    process$: Observable<fromShared.Process>;
    public userInfo$: Observable<fromUser.IUserInfo>;
    labelTextColor: string;
    // data: CompanyCalendar[];
    constructor(
        public entityServices: EntityServices,
        private store: Store,
        private log: LoggingService
    ) {
        this.companyCalendarDataService =
            entityServices.getEntityCollectionService<fromDataServices.CompanyCalendar.CompanyCalendar>(
                fromDataServices.CompanyCalendar.entityName
            );
    }

    ngOnInit(): void {
        // this.companyCalendarDataService.getWithQuery({
        //     ScheduledStartDate: `${moment().month() + 1}/01/${moment().year()}`,
        //     ScheduledEndDate: `${moment().month() + 1}/${this.getMonthEnd()}/${moment().year()}`
        // });
        this.setupObservables();
        this.setupSubscriptions();
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
    }

    ngOnDestroy() {
        this.companyCalendarDataService.clearCache();
        this.active = false;
    }

    getMonthEnd() {
        return new Date(moment().year(), moment().month() + 1, 0).getDate();
    }

    setupObservables() {
        this.companyDates$ = this.companyCalendarDataService.entities$.pipe(
            map(x => clone(x))
        );

        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
    }

    setupSubscriptions() {
        this.companyDates$
            .pipe(takeWhile(() => this.active))
            .subscribe(dates => {
                this.mapDatesToEvents(dates);
            });
    }

    onLoadDates($event) {
        this.log.verbose({
            type: 'CompanyCalendarFeatureComponent:onLoadDates',
            $event
        });
        this.companyCalendarDataService.clearCache();
        this.companyCalendarDataService.getWithQuery($event);
    }

    onLoadAllDates() {
        this.log.verbose({
            type: 'CompanyCalendarFeatureComponent:onLoadAllDates'
        });
        this.companyCalendarDataService.clearCache();
        this.companyCalendarDataService.getAll();
    }

    onSaveEvent($event) {
        this.log.verbose({
            type: 'CompanyCalendarFeatureComponent:onSaveEvent'
        });
        this.companyCalendarDataService.upsert($event);
    }

    onDeleteEvent($event) {
        this.companyCalendarDataService.delete($event);
    }

    hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : { r: 0, g: 0, b: 0 };
    }

    mapDatesToEvents(
        dates: fromDataServices.CompanyCalendar.CompanyCalendar[]
    ) {
        this.events = [];
        dates.map(d => {
            if (d.DateColor != null) {
                if (
                    this.hexToRgb(d.DateColor)?.r +
                        this.hexToRgb(d.DateColor)?.g +
                        this.hexToRgb(d.DateColor)?.b >
                    275
                ) {
                    this.labelTextColor = '#000000';
                } else {
                    this.labelTextColor = '#FFFFFF';
                }
            } else {
                this.labelTextColor = '#FFFFFF';
            }

            this.events = [
                ...this.events,
                {
                    id: d.ScheduledDateID,
                    title: d.ScheduledDatePurpose,
                    start: moment(d.ScheduledStartDate).toDate(),
                    end: moment(d.ScheduledEndDate)
                        .add(1, 'day')
                        .add(1, 'second')
                        .toDate(),
                    backgroundColor: d.DateColor,
                    textColor: this.labelTextColor,
                    allDay: true
                }
            ];
        });
        return this.events;
    }
}
